webpackJsonp([34],{

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_company_vue__ = __webpack_require__(815);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19df70a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_company_vue__ = __webpack_require__(985);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_company_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19df70a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_company_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function clickIcon() {
	this.$emit('click-icon');
}

function isListAll() {
	return this.icon === 'list_all' ? 'height:24px;width:24px' : '';
}

function buttonColor() {
	return this.isEditAction ? '#3B82C4' : this.color;
}

function isEditAction() {
	return ['edit', 'create'].includes(this.icon);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-tooltip-button',
	computed: {
		buttonColor: buttonColor,
		isEditAction: isEditAction,
		isListAll: isListAll
	},
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: 'green'
		},
		icon: {
			type: String,
			required: true
		},
		text: {
			type: String,
			required: true
		}
	},
	methods: {
		clickIcon: clickIcon
	}
});

/***/ }),

/***/ 560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_tooltip_button_vue__ = __webpack_require__(559);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01775c3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_tooltip_button_vue__ = __webpack_require__(564);
function injectStyle (ssrContext) {
  __webpack_require__(562)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01775c3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_tooltip_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01775c3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_tooltip_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(563);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("673c19a2", content, true, {});

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.action-icon-button[data-v-01775c3c]{background:#f2f6f9!important;border:1px solid transparent;border-radius:7px;height:28px;min-width:28px;-webkit-transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease,-webkit-transform .16s ease;width:28px}.action-icon-button .icon[data-v-01775c3c]{font-size:17px}.action-icon-button[data-v-01775c3c]:hover{background:#eaf3ef!important;border-color:#c8ddd5;-webkit-transform:translateY(-1px);transform:translateY(-1px)}.action-icon-button.is-edit-action[data-v-01775c3c]:hover{background:#eaf3fa!important;border-color:#bed8ea}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/app-tooltip-button.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,qCAAqC,6BAA8B,6BAA+B,kBAAkB,YAAY,eAAe,2FAA2F,mFAAmF,2EAA2E,uGAAuG,UAAU,CACxf,AACD,2CAA2C,cAAc,CACxD,AACD,2CAA2C,6BAA8B,qBAAqB,mCAAmC,0BAA0B,CAC1J,AACD,0DAA0D,6BAA8B,oBAAoB,CAC3G","file":"app-tooltip-button.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.action-icon-button[data-v-01775c3c]{background:#f2f6f9 !important;border:1px solid rgba(0,0,0,0);border-radius:7px;height:28px;min-width:28px;-webkit-transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,-webkit-transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease;transition:background .16s ease,border-color .16s ease,transform .16s ease,-webkit-transform .16s ease;width:28px\n}\n.action-icon-button .icon[data-v-01775c3c]{font-size:17px\n}\n.action-icon-button[data-v-01775c3c]:hover{background:#eaf3ef !important;border-color:#c8ddd5;-webkit-transform:translateY(-1px);transform:translateY(-1px)\n}\n.action-icon-button.is-edit-action[data-v-01775c3c]:hover{background:#eaf3fa !important;border-color:#bed8ea\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"action-icon-button ma-0",class:{ 'is-edit-action': _vm.isEditAction },attrs:{"slot":"activator","flat":"","icon":"","aria-label":_vm.text,"small":"","color":_vm.buttonColor,"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.clickIcon.apply(null, arguments)}},slot:"activator"},[_c('v-icon',{style:(_vm.isListAll)},[_vm._v(_vm._s(_vm.icon))])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 588:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function actionToDo(item) {
	var action = item.link ? item.link : {
		width: item.width ? item.width : 0,
		title: item.text,
		code: item.code,
		active: item.active,
		open: true
	};
	var eventEmit = item.link ? 'to-link' : 'open-modal';
	this.$emit(eventEmit, action);
}

function setBorder(item) {
	var color = item.color === undefined ? '#9b9b9b' : item.color;
	return 'border-bottom: 4px solid ' + color;
}

function setMaxWidth(item) {
	var maxWidth = item.maxWidth ? item.maxWidth + 'px' : 'min-content';
	return 'max-width: ' + maxWidth;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'quick-actions',
	methods: {
		actionToDo: actionToDo,
		setBorder: setBorder,
		setMaxWidth: setMaxWidth
	},
	props: {
		actions: Array
	}
});

/***/ }),

/***/ 590:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quick_actions_vue__ = __webpack_require__(588);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16d5e0be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quick_actions_vue__ = __webpack_require__(593);
function injectStyle (ssrContext) {
  __webpack_require__(591)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16d5e0be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quick_actions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16d5e0be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quick_actions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(592);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("2c1c9135", content, true, {});

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.actions[data-v-16d5e0be]{background:transparent;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:0;position:fixed;right:48px;top:59px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;z-index:4}.actions .actions-bar[data-v-16d5e0be]{background:transparent;border:0;border-radius:7px;-webkit-box-shadow:none;box-shadow:none;padding:0}.actions .actions-bar .action-content[data-v-16d5e0be]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;height:36px}.actions .actions-bar .action-content .action[data-v-16d5e0be],.actions .actions-bar .action-content[data-v-16d5e0be]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.actions .actions-bar .action-content .action[data-v-16d5e0be]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#1a4338;border:0!important;border-radius:7px;-webkit-box-shadow:0 2px 6px rgba(26,67,56,.25);box-shadow:0 2px 6px rgba(26,67,56,.25);color:#fff;cursor:pointer;height:32px;margin:0;opacity:.3;outline:none;padding:0 12px;text-align:center;-webkit-transition:background-color .2s ease,-webkit-box-shadow .2s ease,-webkit-transform .2s ease;transition:background-color .2s ease,-webkit-box-shadow .2s ease,-webkit-transform .2s ease;transition:background-color .2s ease,box-shadow .2s ease,transform .2s ease;transition:background-color .2s ease,box-shadow .2s ease,transform .2s ease,-webkit-box-shadow .2s ease,-webkit-transform .2s ease;width:auto}.actions .actions-bar .action-content .action .action-icon[data-v-16d5e0be]{color:#fff;font-size:21px}.actions .actions-bar .action-content .action .action-logo[data-v-16d5e0be]{height:21px;-o-object-fit:contain;object-fit:contain;width:21px}.actions .actions-bar .action-content .action .action-txt[data-v-16d5e0be]{font-family:Opens_regular;font-size:10px;color:#fff;font-size:13px;font-weight:600;margin:0 0 0 7px;max-width:none!important;text-align:left;white-space:nowrap}.actions .actions-bar .action-content .action[data-v-16d5e0be]:focus,.actions .actions-bar .action-content .action[data-v-16d5e0be]:hover{background:#12372e;-webkit-box-shadow:0 4px 10px rgba(26,67,56,.35);box-shadow:0 4px 10px rgba(26,67,56,.35);-webkit-transform:translateY(-2px);transform:translateY(-2px)}.actions .actions-bar .action-content .active[data-v-16d5e0be]{opacity:1}@media(max-width:900px){.actions .actions[data-v-16d5e0be]{margin:7px auto 10px;max-width:calc(100% - 24px);position:relative;right:auto;top:auto}.actions .actions .action-content[data-v-16d5e0be],.actions .actions .actions-bar[data-v-16d5e0be]{max-width:100%}.actions .actions .action-content[data-v-16d5e0be]{-ms-flex-wrap:wrap;flex-wrap:wrap;height:auto!important}}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/quick-actions.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,0BAA0B,uBAAyB,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,uBAAuB,SAAS,eAAe,WAAW,SAAS,0BAA0B,uBAAuB,kBAAkB,SAAS,CACnS,AACD,uCAAuC,uBAAyB,SAAS,kBAAkB,wBAAwB,gBAAgB,SAAS,CAC3I,AACD,uDAAuD,sBAAsB,mBAAmB,qBAAqB,AAA2J,WAAW,CAC1R,AACD,sHAFqH,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,wBAAwB,qBAAqB,sBAAuB,CAG/Q,AADD,+DAA+D,yBAAyB,sBAAsB,mBAAmB,AAA2J,mBAAmB,mBAAoB,kBAAkB,gDAAgD,wCAAwC,WAAW,eAAe,YAAY,SAAS,WAAW,aAAa,eAAe,kBAAkB,oGAAoG,4FAA4F,4EAA4E,mIAAmI,UAAU,CAC76B,AACD,4EAA4E,WAAW,cAAc,CACpG,AACD,4EAA4E,YAAY,sBAAsB,mBAAmB,UAAU,CAC1I,AACD,2EAA2E,0BAA4B,eAAe,WAAW,eAAe,gBAAgB,iBAAiB,yBAA0B,gBAAgB,kBAAkB,CAC5O,AACD,0IAA0I,mBAAmB,iDAAiD,yCAAyC,mCAAmC,0BAA0B,CACnT,AACD,+DAA+D,SAAS,CACvE,AACD,wBACA,mCAAmC,qBAAqB,4BAA4B,kBAAkB,WAAW,QAAQ,CACxH,AACD,mGAAmG,cAAc,CAChH,AACD,mDAAmD,mBAAmB,eAAe,qBAAsB,CAC1G,CACA","file":"quick-actions.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.actions[data-v-16d5e0be]{background:rgba(0,0,0,0);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:0;position:fixed;right:48px;top:59px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;z-index:4\n}\n.actions .actions-bar[data-v-16d5e0be]{background:rgba(0,0,0,0);border:0;border-radius:7px;-webkit-box-shadow:none;box-shadow:none;padding:0\n}\n.actions .actions-bar .action-content[data-v-16d5e0be]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:36px\n}\n.actions .actions-bar .action-content .action[data-v-16d5e0be]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background:#1a4338;border:0 !important;border-radius:7px;-webkit-box-shadow:0 2px 6px rgba(26,67,56,.25);box-shadow:0 2px 6px rgba(26,67,56,.25);color:#fff;cursor:pointer;height:32px;margin:0;opacity:.3;outline:none;padding:0 12px;text-align:center;-webkit-transition:background-color .2s ease,-webkit-box-shadow .2s ease,-webkit-transform .2s ease;transition:background-color .2s ease,-webkit-box-shadow .2s ease,-webkit-transform .2s ease;transition:background-color .2s ease,box-shadow .2s ease,transform .2s ease;transition:background-color .2s ease,box-shadow .2s ease,transform .2s ease,-webkit-box-shadow .2s ease,-webkit-transform .2s ease;width:auto\n}\n.actions .actions-bar .action-content .action .action-icon[data-v-16d5e0be]{color:#fff;font-size:21px\n}\n.actions .actions-bar .action-content .action .action-logo[data-v-16d5e0be]{height:21px;-o-object-fit:contain;object-fit:contain;width:21px\n}\n.actions .actions-bar .action-content .action .action-txt[data-v-16d5e0be]{font-family:\"Opens_regular\";font-size:10px;color:#fff;font-size:13px;font-weight:600;margin:0 0 0 7px;max-width:none !important;text-align:left;white-space:nowrap\n}\n.actions .actions-bar .action-content .action[data-v-16d5e0be]:hover,.actions .actions-bar .action-content .action[data-v-16d5e0be]:focus{background:#12372e;-webkit-box-shadow:0 4px 10px rgba(26,67,56,.35);box-shadow:0 4px 10px rgba(26,67,56,.35);-webkit-transform:translateY(-2px);transform:translateY(-2px)\n}\n.actions .actions-bar .action-content .active[data-v-16d5e0be]{opacity:1\n}\n@media(max-width: 900px){\n.actions .actions[data-v-16d5e0be]{margin:7px auto 10px;max-width:calc(100% - 24px);position:relative;right:auto;top:auto\n}\n.actions .actions .actions-bar[data-v-16d5e0be],.actions .actions .action-content[data-v-16d5e0be]{max-width:100%\n}\n.actions .actions .action-content[data-v-16d5e0be]{-ms-flex-wrap:wrap;flex-wrap:wrap;height:auto !important\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"actions"},[_c('div',{staticClass:"actions-bar"},[_c('div',{staticClass:"action-content"},_vm._l((_vm.actions),function(action,index){return _c('button',{key:index,staticClass:"action",class:{ active: action.active },style:(_vm.setBorder(action)),attrs:{"type":"button"},on:{"click":function($event){return _vm.actionToDo(action)}}},[(action.icon)?_c('v-icon',{staticClass:"action-icon",attrs:{"color":"white"}},[_vm._v(_vm._s(action.icon))]):(action.img)?_c('img',{staticClass:"action-logo",attrs:{"src":action.img,"alt":""}}):_vm._e(),_vm._v(" "),_c('p',{staticClass:"action-txt",style:(_vm.setMaxWidth(action))},[_vm._v(_vm._s(action.text))])],1)}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 815:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_quick_actions__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_companies_company_list__ = __webpack_require__(979);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function created() {
	if (this.$route.name === 'page-company') {
		this.loadData('project/' + this.codeProject + '/companies');
	}
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.loadData('project/' + this.codeProject + '/companies');
}

function openModal() {
	var codeProject = this.codeProject;
	this.goTo('page-new-company', { params: { codeProject: codeProject } });
}

function data() {
	return {
		actions: [{
			id: 1,
			code: 'CC',
			text: 'Crear Compañía',
			icon: 'business',
			active: true
		}],
		columns: [{ id: 1, name: 'Compañía', checked: true, visible: true }, { id: 2, name: 'Código', checked: true, visible: true }, { id: 3, name: 'RUC', checked: true, visible: true }, { id: 4, name: 'Configuración', checked: true, visible: true }, { id: 5, name: 'Plan', checked: true, visible: true }, { id: 6, name: 'Idiomas', checked: true, visible: true }, { id: 7, name: 'Servicios', checked: true, visible: true }, { id: 8, name: 'Actualización', checked: true, visible: true }, { id: 9, name: 'Acciones', checked: true, visible: true, flagVisible: true }],
		currentPage: 1
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-company',
	components: {
		companyList: __WEBPACK_IMPORTED_MODULE_1__components_companies_company_list__["a" /* default */],
		quickActions: __WEBPACK_IMPORTED_MODULE_0__components_shared_quick_actions__["a" /* default */]
	},
	created: created,
	data: data,
	methods: {
		changePage: changePage,
		openModal: openModal
	},
	props: {
		codeProject: {
			type: String
		}
	},
	watch: {
		$route: function $route(newVal) {
			if (newVal) {
				if (newVal.name === 'page-company') {
					this.loadData('project/' + this.codeProject + '/companies');
				}
			}
		}
	}
});

/***/ }),

/***/ 816:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_app_tooltip_button__ = __webpack_require__(560);





var copyToken = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(token) {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						if (token) {
							_context.next = 3;
							break;
						}

						this.showNotification('Esta compañía no tiene token', 'warning');return _context.abrupt('return');

					case 3:
						_context.prev = 3;

						if (!(navigator.clipboard && navigator.clipboard.writeText)) {
							_context.next = 9;
							break;
						}

						_context.next = 7;
						return navigator.clipboard.writeText(token);

					case 7:
						_context.next = 10;
						break;

					case 9:
						legacyCopy(token);

					case 10:
						this.showNotification('Token copiado');
						_context.next = 17;
						break;

					case 13:
						_context.prev = 13;
						_context.t0 = _context['catch'](3);

						legacyCopy(token);
						this.showNotification('Token copiado');

					case 17:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[3, 13]]);
	}));

	return function copyToken(_x2) {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function changePage(page) {
	this.$emit('change-page', page);
}
function initials() {
	var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

	return name.split(/\s+/).filter(Boolean).slice(0, 2).map(function (word) {
		return word[0];
	}).join('').toUpperCase() || 'CO';
}
function countryName(row) {
	return row.country && row.country.data ? row.country.data.name : 'Sin país';
}
function templateName(row) {
	var name = row.template && row.template.data ? row.template.data.name : '';
	return name ? name.replace(/\*+/g, '').trim() : 'Sin template';
}
function planName(row) {
	var plans = row.selectPlans;
	if (Array.isArray(plans)) return plans.length && plans[0].name ? plans[0].name : 'Sin plan';
	return plans && plans.name ? plans.name : 'Sin plan';
}
function planEndDate(row) {
	var plans = row.selectPlans;
	var plan = Array.isArray(plans) ? plans[0] : plans;
	if (!plan || !plan.end_date) return 'Sin vigencia';
	var date = new Date(plan.end_date.replace(' ', 'T'));
	if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan___default()(date.getTime())) return plan.end_date;
	return 'Vence ' + date.toLocaleDateString('es-EC', { day: '2-digit', month: 'short', year: 'numeric' });
}
function selectedLanguages(row) {
	return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(row.languages || {}).filter(function (key) {
		return row.languages[key] && row.languages[key].isSelected;
	}).map(function (key) {
		return (row.languages[key].id || key).toUpperCase();
	});
}
function integrationsCount(row) {
	var services = row.settings && Array.isArray(row.settings.serviceExternal) ? row.settings.serviceExternal : [];
	return services.filter(function (service) {
		return service.flagSelected !== false;
	}).length;
}
function formattedUpdatedAt(row) {
	var value = row.template && row.template.data ? row.template.data.updatedAt : null;
	if (!value) return 'Sin fecha';
	var date = new Date(value.replace(' ', 'T'));
	if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan___default()(date.getTime())) return value;
	return date.toLocaleDateString('es-EC', { day: '2-digit', month: 'short', year: 'numeric' });
}
function legacyCopy(value) {
	var input = document.createElement('textarea');
	input.value = value;
	input.setAttribute('readonly', '');
	input.style.position = 'fixed';
	input.style.opacity = '0';
	document.body.appendChild(input);
	input.select();
	document.execCommand('copy');
	document.body.removeChild(input);
}

function edit(_ref2) {
	var id = _ref2.id,
	    nombreComercial = _ref2.nombreComercial,
	    codeCompany = _ref2.codeCompany;

	this.goTo('page-edit-company', { params: { idCompany: id, codeCompany: codeCompany, nameCompany: nombreComercial } });
}
function onSearch(value) {
	this.$emit('on-search', value);
}
function openRoles(_ref3) {
	var codeCompany = _ref3.codeCompany;
	this.goTo('page-role', { params: { codeCompany: codeCompany, codeProject: this.codeProject } });
}
function goToUsers(_ref4) {
	var codeCompany = _ref4.codeCompany;
	this.goTo('page-user', { params: { codeProject: this.codeProject, idCompany: codeCompany } });
}
function openIntegrations(_ref5) {
	var codeCompany = _ref5.codeCompany;
	this.goTo('page-company-integration', { params: { codeCompany: codeCompany, codeProject: this.codeProject } });
}
function openTemplate(row) {
	var template = row.template && row.template.data;
	var codeTemplate = template && template.codeTemplate;
	if (!codeTemplate) {
		this.showNotification('Esta compañía no tiene un template asignado', 'warning');
		return;
	}
	this.goTo('page-template', {
		params: { codeProject: this.codeProject },
		query: { search: codeTemplate }
	});
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'companies-list',
	components: { appTooltipButton: __WEBPACK_IMPORTED_MODULE_4__components_shared_app_tooltip_button__["a" /* default */] },
	props: {
		codeProject: { type: String, required: true },
		columns: { type: Array, required: true },
		currentPage: { type: Number, default: 0 },
		lastPage: { type: Number, default: 0 },
		rows: { type: Array, required: true },
		searchValue: { type: String, default: '' }
	},
	methods: {
		changePage: changePage,
		copyToken: copyToken,
		countryName: countryName,
		edit: edit,
		formattedUpdatedAt: formattedUpdatedAt,
		goToUsers: goToUsers,
		initials: initials,
		integrationsCount: integrationsCount,
		onSearch: onSearch,
		openIntegrations: openIntegrations,
		openRoles: openRoles,
		openTemplate: openTemplate,
		planEndDate: planEndDate,
		planName: planName,
		selectedLanguages: selectedLanguages,
		templateName: templateName
	}
});

/***/ }),

/***/ 979:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_list_vue__ = __webpack_require__(816);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d0740be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_list_vue__ = __webpack_require__(984);
function injectStyle (ssrContext) {
  __webpack_require__(980)
  __webpack_require__(982)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d0740be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d0740be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 980:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(981);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("1d63de18", content, true, {});

/***/ }),

/***/ 981:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.company-list[data-v-7d0740be]{padding-bottom:70px}.company-actions[data-v-7d0740be]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;white-space:nowrap}.company-actions-cell[data-v-7d0740be]{min-width:0;padding-left:4px!important;padding-right:4px!important}.company-name-column[data-v-7d0740be]{padding-left:12px!important;text-align:left!important}.company-identity[data-v-7d0740be]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;gap:7px;min-width:0}.company-primary-data[data-v-7d0740be]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:0}.company-identity strong[data-v-7d0740be]{color:#29435b;font-size:11px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.company-identity small[data-v-7d0740be]{color:#8494a3;font-size:9px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.company-avatar[data-v-7d0740be]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#e5f2fc;border-radius:7px;color:#1875c4;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 28px;flex:0 0 28px;font-size:9px;font-weight:700;height:28px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.company-code-column[data-v-7d0740be]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;white-space:nowrap}.company-code-column strong[data-v-7d0740be],.company-ruc-column strong[data-v-7d0740be]{color:#40586e;font-size:9px}.company-code-column>.btn[data-v-7d0740be]{height:25px!important;margin:0 0 0 4px;min-width:25px!important;width:25px}.company-ruc-column[data-v-7d0740be]{white-space:nowrap}.company-configuration-column small[data-v-7d0740be],.company-languages-column>small[data-v-7d0740be],.company-plan-column small[data-v-7d0740be],.company-updated-column small[data-v-7d0740be]{color:#8a9baa;display:block;font-size:8px}.company-configuration-column[data-v-7d0740be],.company-languages-column[data-v-7d0740be],.company-plan-column[data-v-7d0740be],.company-services-column[data-v-7d0740be],.company-updated-column[data-v-7d0740be]{text-align:left!important}.company-configuration-column>strong[data-v-7d0740be]{color:#344f67;display:block;font-size:10px}.company-configuration-column>small[data-v-7d0740be],.company-plan-column>strong[data-v-7d0740be]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.company-plan-column>strong[data-v-7d0740be]{color:#3576a9;display:block;font-size:9px}.language-chips[data-v-7d0740be]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;gap:3px;margin-bottom:3px}.language-chips span[data-v-7d0740be]{background:#e7f4ed;border-radius:5px;color:#258457;font-size:8px;font-weight:700;padding:2px 5px}.company-services-column>small[data-v-7d0740be]{color:#71879a;font-size:8px}.access-status[data-v-7d0740be]{color:#458362;display:block;font-size:8px;margin-top:2px}.access-status.restricted[data-v-7d0740be]{color:#d16a3c}.company-updated-column strong[data-v-7d0740be]{color:#425d73;display:block;font-size:10px}@media(max-width:700px){.company-list[data-v-7d0740be]{padding-left:12px!important;padding-right:12px!important}}", "", {"version":3,"sources":["/opt/build/repo/src/components/companies/company-list.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,+BAA+B,mBAAmB,CACjD,AACD,kCAAkC,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,uBAAuB,kBAAkB,CAC9O,AACD,uCAAuC,YAAY,2BAA4B,2BAA4B,CAC1G,AACD,sCAAsC,4BAA6B,yBAA0B,CAC5F,AACD,mCAAmC,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,aAAa,QAAQ,WAAW,CAC5K,AACD,uCAAuC,oBAAoB,oBAAoB,aAAa,mBAAmB,kBAAkB,cAAc,4BAA4B,6BAA6B,0BAA0B,sBAAsB,WAAW,CAClQ,AACD,0CAA0C,cAAc,eAAe,gBAAgB,uBAAuB,kBAAkB,CAC/H,AACD,yCAAyC,cAAc,cAAc,gBAAgB,uBAAuB,kBAAkB,CAC7H,AACD,iCAAiC,yBAAyB,sBAAsB,mBAAmB,mBAAmB,kBAAkB,cAAc,oBAAoB,oBAAoB,aAAa,mBAAmB,kBAAkB,cAAc,cAAc,gBAAgB,YAAY,wBAAwB,qBAAqB,sBAAsB,CAC1W,AACD,sCAAsC,yBAAyB,sBAAsB,mBAAmB,kBAAkB,CACzH,AACD,yFAAyF,cAAc,aAAa,CACnH,AACD,2CAA2C,sBAAuB,iBAAiB,yBAA0B,UAAU,CACtH,AACD,qCAAqC,kBAAkB,CACtD,AACD,iMAAiM,cAAc,cAAc,aAAa,CACzO,AACD,mNAAmN,yBAA0B,CAC5O,AACD,sDAAsD,cAAc,cAAc,cAAc,CAC/F,AAGD,kGAFqD,gBAAgB,uBAAuB,kBAAkB,CAG7G,AADD,6CAA6C,cAAc,cAAc,aAAc,CACtF,AACD,iCAAiC,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,aAAa,QAAQ,iBAAiB,CAChL,AACD,sCAAsC,mBAAmB,kBAAkB,cAAc,cAAc,gBAAgB,eAAe,CACrI,AACD,gDAAgD,cAAc,aAAa,CAC1E,AACD,gCAAgC,cAAc,cAAc,cAAc,cAAc,CACvF,AACD,2CAA2C,aAAa,CACvD,AACD,gDAAgD,cAAc,cAAc,cAAc,CACzF,AACD,wBACA,+BAA+B,4BAA6B,4BAA6B,CACxF,CACA","file":"company-list.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.company-list[data-v-7d0740be]{padding-bottom:70px\n}\n.company-actions[data-v-7d0740be]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;white-space:nowrap\n}\n.company-actions-cell[data-v-7d0740be]{min-width:0;padding-left:4px !important;padding-right:4px !important\n}\n.company-name-column[data-v-7d0740be]{padding-left:12px !important;text-align:left !important\n}\n.company-identity[data-v-7d0740be]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;gap:7px;min-width:0\n}\n.company-primary-data[data-v-7d0740be]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:0\n}\n.company-identity strong[data-v-7d0740be]{color:#29435b;font-size:11px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap\n}\n.company-identity small[data-v-7d0740be]{color:#8494a3;font-size:9px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap\n}\n.company-avatar[data-v-7d0740be]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#e5f2fc;border-radius:7px;color:#1875c4;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 28px;flex:0 0 28px;font-size:9px;font-weight:700;height:28px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n.company-code-column[data-v-7d0740be]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;white-space:nowrap\n}\n.company-code-column strong[data-v-7d0740be],.company-ruc-column strong[data-v-7d0740be]{color:#40586e;font-size:9px\n}\n.company-code-column>.btn[data-v-7d0740be]{height:25px !important;margin:0 0 0 4px;min-width:25px !important;width:25px\n}\n.company-ruc-column[data-v-7d0740be]{white-space:nowrap\n}\n.company-configuration-column small[data-v-7d0740be],.company-plan-column small[data-v-7d0740be],.company-languages-column>small[data-v-7d0740be],.company-updated-column small[data-v-7d0740be]{color:#8a9baa;display:block;font-size:8px\n}\n.company-configuration-column[data-v-7d0740be],.company-plan-column[data-v-7d0740be],.company-languages-column[data-v-7d0740be],.company-services-column[data-v-7d0740be],.company-updated-column[data-v-7d0740be]{text-align:left !important\n}\n.company-configuration-column>strong[data-v-7d0740be]{color:#344f67;display:block;font-size:10px\n}\n.company-configuration-column>small[data-v-7d0740be]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap\n}\n.company-plan-column>strong[data-v-7d0740be]{color:#3576a9;display:block;font-size:9px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap\n}\n.language-chips[data-v-7d0740be]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;gap:3px;margin-bottom:3px\n}\n.language-chips span[data-v-7d0740be]{background:#e7f4ed;border-radius:5px;color:#258457;font-size:8px;font-weight:700;padding:2px 5px\n}\n.company-services-column>small[data-v-7d0740be]{color:#71879a;font-size:8px\n}\n.access-status[data-v-7d0740be]{color:#458362;display:block;font-size:8px;margin-top:2px\n}\n.access-status.restricted[data-v-7d0740be]{color:#d16a3c\n}\n.company-updated-column strong[data-v-7d0740be]{color:#425d73;display:block;font-size:10px\n}\n@media(max-width: 700px){\n.company-list[data-v-7d0740be]{padding-left:12px !important;padding-right:12px !important\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 982:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(983);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("40d0ea9e", content, true, {});

/***/ }),

/***/ 983:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.companies-table .table-list{table-layout:fixed}.companies-table .table-list>tbody>tr{height:44px!important;min-height:44px!important}.companies-table .table-list>tbody>tr>td{height:44px!important;padding-bottom:3px!important;padding-top:3px!important}.companies-table .table-list .company-actions .btn{margin-left:1px;margin-right:1px;min-width:27px;width:27px;height:27px!important;min-height:27px!important}", "", {"version":3,"sources":["/opt/build/repo/src/components/companies/company-list.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,6BAA6B,kBAAkB,CAC9C,AACD,sCAAsC,sBAAuB,yBAA0B,CACtF,AACD,yCAAyC,sBAAuB,6BAA8B,yBAA0B,CACvH,AACD,mDAAmD,gBAAgB,iBAAiB,eAAe,WAAU,AAE1D,sBAAuB,yBAA0B,CADnG","file":"company-list.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.companies-table .table-list{table-layout:fixed\n}\n.companies-table .table-list>tbody>tr{height:44px !important;min-height:44px !important\n}\n.companies-table .table-list>tbody>tr>td{height:44px !important;padding-bottom:3px !important;padding-top:3px !important\n}\n.companies-table .table-list .company-actions .btn{margin-left:1px;margin-right:1px;min-width:27px;width:27px\n}\n.companies-table .table-list .company-actions .btn{height:27px !important;min-height:27px !important\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 984:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-list px-5"},[_c('app-table',{staticClass:"companies-table is-not-selectable",attrs:{"compact":"","contained":"","sticky-header":"","name":"companies","columns":_vm.columns,"column-widths":{ 1: '19%', 2: '8%', 3: '10%', 4: '20%', 5: '11%', 6: '7%', 7: '9%', 8: '8%', 9: '8%' },"current-page":_vm.currentPage,"rows":_vm.rows,"last-page":_vm.lastPage,"search-value":_vm.searchValue},on:{"on-search-event":_vm.onSearch,"on-page":_vm.changePage},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"company-name-column"},[_c('div',{staticClass:"company-identity"},[_c('span',{staticClass:"company-avatar"},[_vm._v(_vm._s(_vm.initials(props.row.nombreComercial)))]),_vm._v(" "),_c('div',{staticClass:"company-primary-data"},[_c('strong',{attrs:{"title":props.row.nombreComercial}},[_vm._v(_vm._s(props.row.nombreComercial))]),_vm._v(" "),_c('small',{attrs:{"title":props.row.razonSocial}},[_vm._v(_vm._s(props.row.razonSocial || 'Sin razón social'))])])])]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}],staticClass:"company-code-column"},[_c('app-tooltip-button',{attrs:{"color":"primary","icon":"content_copy","text":"Copiar token"},on:{"click-icon":function($event){return _vm.copyToken(props.row.hash)}}}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(props.row.codeCompany || '—'))])],1),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}],staticClass:"company-ruc-column"},[_c('strong',[_vm._v(_vm._s(props.row.ruc || '—'))])]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 4)),expression:"showRow(columns, 4)"}],staticClass:"company-configuration-column"},[_c('strong',[_vm._v(_vm._s(_vm.countryName(props.row)))]),_vm._v(" "),_c('small',{attrs:{"title":_vm.templateName(props.row)}},[_vm._v(_vm._s(_vm.templateName(props.row)))])]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 5)),expression:"showRow(columns, 5)"}],staticClass:"company-plan-column"},[_c('strong',[_vm._v(_vm._s(_vm.planName(props.row)))]),_c('small',[_vm._v(_vm._s(_vm.planEndDate(props.row)))])]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 6)),expression:"showRow(columns, 6)"}],staticClass:"company-languages-column"},[_c('div',{staticClass:"language-chips"},[_vm._l((_vm.selectedLanguages(props.row)),function(language){return _c('span',{key:language},[_vm._v(_vm._s(language))])}),(!_vm.selectedLanguages(props.row).length)?_c('small',[_vm._v("—")]):_vm._e()],2),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.selectedLanguages(props.row).length ? 'Habilitados' : 'Sin idiomas'))])]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 7)),expression:"showRow(columns, 7)"}],staticClass:"company-services-column"},[_c('small',[_vm._v(_vm._s(_vm.integrationsCount(props.row))+" integraciones")]),_vm._v(" "),_c('span',{class:['access-status', { restricted: props.row.flagAllowAccess }]},[_vm._v(_vm._s(props.row.flagAllowAccess ? 'Acceso restringido' : 'Acceso normal'))])]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 8)),expression:"showRow(columns, 8)"}],staticClass:"company-updated-column"},[_c('strong',[_vm._v(_vm._s(_vm.formattedUpdatedAt(props.row)))]),_c('small',[_vm._v("Template actualizado")])]),_vm._v(" "),_c('td',{staticClass:"company-actions-cell"},[_c('div',{staticClass:"company-actions"},[_c('app-tooltip-button',{attrs:{"color":"green","icon":"edit","text":"Editar Compañía"},on:{"click-icon":function($event){return _vm.edit(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"orange","icon":"description","text":"Abrir Template"},on:{"click-icon":function($event){return _vm.openTemplate(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"primary","icon":"people_outline","text":"Usuarios"},on:{"click-icon":function($event){return _vm.goToUsers(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"red","icon":"playlist_add_check","text":"Roles"},on:{"click-icon":function($event){return _vm.openRoles(props.row)}}}),_vm._v(" "),_c('app-tooltip-button',{attrs:{"color":"green","icon":"share","text":"Integraciones"},on:{"click-icon":function($event){return _vm.openIntegrations(props.row)}}})],1)])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 985:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.showParentView('page-company'))?_c('div',[_c('header-page',{attrs:{"name":"companies","title":_vm.$route.meta.title}}),_vm._v(" "),_c('company-list',{attrs:{"codeProject":_vm.codeProject,"columns":_vm.columns,"current-page":_vm.currentPage,"rows":_vm.table.rows,"last-page":_vm.table.lastPage,"search-value":_vm.params.search || ''},on:{"change-page":_vm.changePage,"on-search":function($event){return _vm.onSearch($event, ("project/" + _vm.codeProject + "/companies"))}}}),_vm._v(" "),_c('quick-actions',{attrs:{"actions":_vm.actions},on:{"open-modal":_vm.openModal}})],1):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/34.f54df9f7edb10409394a.js